import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttributeRevertNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20.4 7.69691V22.8H21.6C22.2633 22.8 22.8 22.2633 22.8 21.6V7.20001L20.4 7.69691Z"
        fill={color}
      />
      <path
        d="M22.4484 6.35162L20.4 7.69692L22.8 7.20002C22.8 6.88122 22.6735 6.57652 22.4484 6.35162Z"
        fill={color}
      />
      <path
        d="M17.6484 1.55161C17.4234 1.32661 17.1187 1.20001 16.8 1.20001H16.3031V3.60001L20.4 7.69691L22.4484 6.35161L17.6484 1.55161Z"
        fill={color}
      />
      <path
        d="M3.60001 1.20001H2.40001C1.73671 1.20001 1.20001 1.73671 1.20001 2.40001V21.6C1.20001 22.2633 1.73671 22.8 2.40001 22.8H3.60001V1.20001Z"
        fill={color}
      />
      <path d="M20.4 20.4H3.59998V22.8H20.4V20.4Z" fill={color} />
      <path
        d="M16.2248 12L17.5268 14.26C17.6151 14.4133 17.8098 14.4133 17.8981 14.26L19.2001 12H16.2248Z"
        fill={color}
      />
      <path
        d="M7.32542 7.33237L8.59572 8.60737C10.4719 6.73237 13.5281 6.73467 15.4031 8.60737L16.6734 7.33357C14.0953 4.76007 9.90122 4.76127 7.32542 7.33237Z"
        fill={color}
      />
      <path
        d="M16.6735 7.33356L15.4032 8.60736C16.4836 9.68436 16.9782 11.1691 16.7649 12.6797L18.5461 12.9328C18.8414 10.8551 18.1594 8.81366 16.6735 7.33356Z"
        fill={color}
      />
      <path
        d="M7.77523 12L6.47323 9.73998C6.38493 9.58668 6.19023 9.58668 6.10193 9.73998L4.79993 12H7.77523Z"
        fill={color}
      />
      <path
        d="M15.4031 15.3937C13.5281 17.2664 10.4718 17.2617 8.59682 15.3937L7.32532 16.6687C8.61442 17.9531 10.3066 18.5952 11.9999 18.5952C13.6921 18.5952 15.3843 17.953 16.6734 16.6687L15.4031 15.3937Z"
        fill={color}
      />
      <path
        d="M7.23521 11.3203L5.45401 11.0672C5.15871 13.1437 5.84071 15.1852 7.32551 16.6688L8.59701 15.3938C7.51661 14.3157 7.02071 12.8308 7.23521 11.3203Z"
        fill={color}
      />
      <path
        d="M16.3031 1.20001H3.59998V3.60001H16.3031V1.20001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttributeRevertNsk.displayName = 'AttributeRevertNsk';
